module.exports = __webpack_public_path__ + "img/samb-icon-app.be29fd73.png";